import React, { useState } from "react";

import { MDBRow, MDBCol } from "mdbreact";

import ProjectVideo from "./ProjectVideo";

const Video = ({ folder, type, videos }) => {
  const [video, setVideo] = useState(0);

  return (
    <React.Fragment>
      <ProjectVideo
        autoPlay={true}
        src={
          videos[video].type === "generic"
            ? `../images/${folder}/generic/videos/${videos[video].video}`
            : `../images/${folder}/${type}/videos/${videos[video].video}`
        }
      />
      {videos.length > 1 ? (
        <MDBRow>
          <MDBCol className="">
            <button
              type="button"
              disabled={video <= 0}
              className={`btn btn-sm ml-0 ${video > 0 ? "btn-info" : "btn-secondary"}`}
              onClick={() => {
                setVideo(video - 1);
              }}
            >
              ANTERIOR
            </button>
          </MDBCol>
          <MDBCol className="text-right">
            <button
              type="button"
              disabled={video >= videos.length - 1}
              className={`btn btn-sm mr-0 ${
                video < videos.length - 1 ? "btn-info" : "btn-secondary"
              }`}
              onClick={() => {
                setVideo(video + 1);
              }}
            >
              SIGUIENTE
            </button>
          </MDBCol>
        </MDBRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default Video;
